import React, { createContext, useContext, useState, useCallback } from 'react'
import en from '../i18n/en.json'
import es from '../i18n/es.json'

const translations = { en, es }

export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Espa\u00f1ol' },
]

const I18nContext = createContext(null)

export function I18nProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    return localStorage.getItem('tabowe_locale') || 'en'
  })

  const changeLocale = useCallback((code) => {
    setLocale(code)
    localStorage.setItem('tabowe_locale', code)
  }, [])

  /**
   * Translate a key path like "dashboard.hey" with optional interpolation.
   * t('dashboard.hey', { name: 'John' }) => "Hey, John"
   */
  const t = useCallback((keyPath, vars = {}) => {
    const keys = keyPath.split('.')
    let value = translations[locale]

    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k]
      } else {
        // Fallback to English
        value = translations.en
        for (const fk of keys) {
          if (value && typeof value === 'object' && fk in value) {
            value = value[fk]
          } else {
            return keyPath // Key not found at all
          }
        }
        break
      }
    }

    if (typeof value !== 'string') return keyPath

    // Interpolate {name} style variables
    return value.replace(/\{(\w+)\}/g, (_, key) => vars[key] ?? `{${key}}`)
  }, [locale])

  return (
    <I18nContext.Provider value={{ locale, changeLocale, t }}>
      {children}
    </I18nContext.Provider>
  )
}

export const useI18n = () => {
  const ctx = useContext(I18nContext)
  if (!ctx) throw new Error('useI18n must be used within I18nProvider')
  return ctx
}
